'use strict'

module.exports = {
  kWebSocketURL: Symbol('url'),
  kReadyState: Symbol('ready state'),
  kController: Symbol('controller'),
  kResponse: Symbol('response'),
  kExtensions: Symbol('extensions'),
  kProtocol: Symbol('protocol'),
  kBinaryType: Symbol('binary type'),
  kClosingFrame: Symbol('closing frame'),
  kSentClose: Symbol('sent close'),
  kReceivedClose: Symbol('received close'),
  kByteParser: Symbol('byte parser')
}
